import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
import { AppDataContext, VLink } from "../AppDataContext";
import { Helmet } from "react-helmet";
import LoginAndRegistration from "../LoginAndRegistration";
import useNetwork from '../../useNetwork';
import { ConfirmDialog } from '../ConfirmDialog';

export function AccountLayout(props) {

    const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);
    const [message, setMessage] = useState(null);

    //if (networkError) {
    //    //return netRenderError();
    //    if (networkError === "Unauthorized") {
    //        return <Redirect to="/login" />;
    //    }
    //    return <Redirect to="/error" status={networkError} />

    //}
    //if (loading)
    //    return <></>

    useEffect(() => {
        setMessage(null);
    }, [context.isLoggedIn]);


    const deactivateAccount = async () => {
        const url = 'api/site/deactivateaccount';
        let postData = '';
        const resp = await netRequest(url, postData);

        if (resp.isError) {
            return "An error occurred. Please try again.  If this continues, close and reopen your browser. (code: " + resp.status + ")";
        } else {
            if (resp.data != null) {
                if (resp.data.isError == false) {
                    context.loggedOut();
                    setMessage(resp.data.message)                    
                }
                return null;
            }

        }
    }


    const modalDeactivateOkClicked = async () => {
        var errorMessage = await deactivateAccount();
        return errorMessage;
    }

    return (
        <>

            <ConfirmDialog cancelText="No" okText="Yes"
                okClicked={modalDeactivateOkClicked}
                id="deactivateConfirmModal"
                headerText="Confirm Account Deactivation"
                modalSize='modal-md'
            >
                Are you sure you want to deactivate your account?

            </ConfirmDialog>

            { message &&
                <div class="row mt-5">
                    <div class="offset-md-2 col-md-8 offset-lg-3 col-lg-6 offset-xl-4 col-xl-4">
                        <div class="alert alert-success">{message}</div>
                    </div>
                </div>
            }

            {context.isLoggedIn == false ?

                <div className={"row mb-5" + ( message!=null ? "": " mt-5" ) }>
                    <div class="offset-md-2 col-md-8 offset-lg-3 col-lg-6 offset-xl-4 col-xl-4">
                        <LoginAndRegistration
                            showLogin={true}
                            showSignup={false} />
                    </div>
                </div>
                :

                <>

                    <Helmet>
                        <title>Account</title>
                    </Helmet>
                    <main>
                        <section class="background-color py-5">
                            <div class="container-fluid container-lg">

                                <div class="row background-white">
                                    <div class="col-12 col-md-3">
                                        <div class="h-100 p-3 flex-column__nav">
                                            <h1 class="display-6">My Account</h1>
                                            <div class="divider mb-3"></div>
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <VLink to="/account" class="nav-link">Summary</VLink>
                                                </li>
                                                <li class="nav-item">
                                                    <VLink to="/account/personalinfo" class="nav-link">Personal Information</VLink>
                                                </li>
                                                <li class="nav-item">
                                                    <VLink to="/account/bids/currentbids" class="nav-link">Bidding History</VLink>
                                                </li>
                                                <li class="nav-item">
                                                    <VLink to="/account/Notifications" class="nav-link">Notifications</VLink>
                                                </li>
                                                <li class="nav-item">
                                                    <VLink to="/account/Payment" class="nav-link">Payment Settings</VLink>
                                                </li>

                                                <li class="nav-item">
                                                    <VLink to="/account/TaxCerts" class="nav-link">Tax Certificates</VLink>
                                                </li>

                                                <li class="nav-item">
                                                    <VLink to="/account/Logout" class="nav-link">Logout</VLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-9 border-left-md border-right-md">
                                        {props.children}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </>
            }
        </>
    );

}
